<template>
  <v-row class="toolbar">
    <v-col cols="auto" v-if="showBackIcon">
      <div class="icon" @click="back">
        <v-icon size="30">mdi-chevron-left</v-icon>
      </div>
    </v-col>
    <v-col cols="auto">
      <div class="title is-size-5">{{ title }}</div>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="auto">
      <div class="function-buttons">
        <slot></slot>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    title () {
      const key = this.config.name
      return this.$t(`toolbar.${key}`)
    },
    showBackIcon () {
      return this.config.back !== undefined
    }
  },
  methods: {
    back () {
      if (this.config.back.length) return this.$router.push(this.config.back)
      this.$router.back(this.config.back)
    }
  }
}
</script>

<style lang="stylus">
  .function-buttons
    height 100%
    > .button
      display inline-flex
      cursor pointer
      padding 4px
      &:not(:last-child)
        margin-right 40px
</style>
